<template>
	<div ref="mapElement" class="h-64 w-full"></div>
</template>

<script lang="ts" setup>
	import { ref, onMounted } from 'vue'
	import { Loader } from '@googlemaps/js-api-loader'
	import useToasterStore from '@/stores/toaster'
	import axios from 'axios'

	const toaster = useToasterStore()
	const mapElement = ref<HTMLElement>()

	const props = defineProps({
		address: {
			type: String,
			required: false,
			default: undefined
		},
		what3words: {
			type: String,
			required: false,
			default: ''
		}
	})

	onMounted(async () => {
		if (!mapElement.value) {
			console.error('Map element is not defined')
			return
		}

		const loader = new Loader({
			apiKey: import.meta.env.VITE_GOOGLE_MAPS_API,
			version: 'weekly'
		})

		try {
			const google = await loader.load()
			let location

			if (props.what3words) {
				try {
					const response = await axios.get(
						`https://api.what3words.com/v3/convert-to-coordinates?words=${props.what3words}&key=${import.meta.env.VITE_WHAT3WORDS_API}`
					)

					const coordinates = response.data.coordinates
					location = new google.maps.LatLng(coordinates.lat, coordinates.lng)

					const map = new google.maps.Map(mapElement.value, {
						center: location,
						zoom: 14,
						disableDefaultUI: true,
						zoomControl: true
					})

					new google.maps.Marker({
						map,
						position: location
					})
				} catch (error) {
					console.error('Error getting What3Words coordinates:', error)
					toaster.error({
						text: 'Error occurred getting What3Words coordinates'
					})
				}
			} else if (props.address) {
				const geocoder = new google.maps.Geocoder()
				geocoder.geocode({ address: props.address }, (results: any, status) => {
					if (status === 'OK') {
						location = results[0].geometry.location

						const map = new google.maps.Map(mapElement.value!, {
							center: location,
							zoom: 14,
							disableDefaultUI: true,
							zoomControl: true
						})

						new google.maps.Marker({
							map,
							position: location
						})
					} else {
						console.error(
							'Geocode was not successful for the following reason: ' + status
						)
						toaster.error({
							text: 'Error occurred getting Google Maps data'
						})
					}
				})
			} else {
				throw new Error('No address or coordinates provided')
			}

			if (location) {
				const map = new google.maps.Map(mapElement.value, {
					center: location,
					zoom: 14,
					disableDefaultUI: true,
					zoomControl: true
				})

				new google.maps.Marker({
					map,
					position: location
				})
			}
		} catch (error) {
			console.error('Error loading Google Maps API:', error)
			toaster.error({
				text: 'Error occurred getting Google Maps data'
			})
		}
	})
</script>
